import React from 'react';
export const About = (props) => {
	return (
		<section
			id='about-section'
			className='about section'
        >
			<h2 className='about-header section-header'>
				About Me
			</h2>
			<p>
                I'm a Full Stack Engineer based in Kansas City, MO, passionate about
                learning and exploring new technologies. I specialize in the frontend, working
                with Javascript, Vue, React, CSS, etc., but I do also have experience with
                PHP/Laravel and Node.js on the backend.
			</p>
            <p>
                I strive to learn something new from each application I create, and I'm
                always searching for the next project to move forward with. I care a
                lot about making responsive and accessible websites and applications
                that are beautiful and innovative. I prioritize the user experience
                above all else.
            </p>
			<p>
				I am always searching for my next opportunity, so drop me a line if
				you're interested in collaborating with me!
            </p>
		</section>
	);
};
